import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Pencil } from "lucide-react";
import { useApi } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Card, Btn, Loading, Overline } from "../components/kit";
import { ItemDialog, MoveDialog } from "../components/stock/StockDialogs";
import { CATEGORY_LABEL, MOVE_LABEL, num, fmtDateTime } from "../lib/constants";

export default function StockItem() {
  const { id } = useParams();
  const { user } = useAuth();
  const canEdit = ["admin", "gudang"].includes(user.role);
  const { data: i, mutate } = useApi(`/items/${id}`);
  const [edit, setEdit] = useState(false);
  const [mode, setMode] = useState(null);
  if (!i) return <Loading />;
  const low = i.stock <= i.min_stock;
  const done = () => { setEdit(false); setMode(null); mutate(); };
  return (
    <>
      <div className="flex items-center justify-between">
        <Link to="/stok" className="inline-flex items-center gap-1 text-slate-600 font-semibold h-11" data-testid="back-to-stock"><ArrowLeft className="w-5 h-5" /> Stok</Link>
        {canEdit && <Btn variant="secondary" onClick={() => setEdit(true)} data-testid="edit-item-btn"><Pencil className="w-4 h-4" /> Edit</Btn>}
      </div>
      <Card className={low ? "border-rose-300 border-2" : ""}>
        <Overline>{CATEGORY_LABEL[i.category]}</Overline>
        <h1 className="text-2xl font-extrabold mt-1" data-testid="item-detail-name">{i.name}</h1>
        <div className="mt-3 flex items-end gap-2"><span className={`text-5xl font-extrabold font-mono ${low ? "text-rose-600" : ""}`} data-testid="item-detail-stock">{num(i.stock)}</span><span className="text-slate-500 mb-2">{i.unit} · minimum {num(i.min_stock)}</span></div>
        {canEdit && (
          <div className="mt-4 grid grid-cols-3 gap-2">
            <Btn variant="success" onClick={() => setMode("in")} data-testid="detail-in-btn">Masuk</Btn>
            <Btn variant="danger" onClick={() => setMode("out")} data-testid="detail-out-btn">Keluar</Btn>
            <Btn variant="dark" onClick={() => setMode("opname")} data-testid="detail-opname-btn">Opname</Btn>
          </div>
        )}
      </Card>
      <Card data-testid="movement-history">
        <h3 className="font-bold text-lg mb-2">Riwayat Mutasi</h3>
        {i.movements.length === 0 ? <p className="text-sm text-slate-500">Belum ada mutasi.</p> : (
          <div className="divide-y divide-slate-100">
            {i.movements.map((m) => (
              <div key={m.id} className="py-3 flex justify-between gap-3" data-testid={`movement-${m.id}`}>
                <div className="min-w-0">
                  <div className="font-semibold text-sm">{MOVE_LABEL[m.type] || m.type}{m.supplier && ` · ${m.supplier}`}</div>
                  <div className="text-xs text-slate-500">{fmtDateTime(m.created_at)} · {m.user_name}</div>
                  {m.note && <div className="text-xs text-slate-600">{m.note}</div>}
                </div>
                <div className="text-right font-mono shrink-0">
                  <div className={`font-bold ${m.qty >= 0 ? "text-emerald-600" : "text-rose-600"}`}>{m.qty >= 0 ? "+" : ""}{num(m.qty)}</div>
                  <div className="text-xs text-slate-400">{num(m.before)} → {num(m.after)}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
      <ItemDialog open={edit} item={i} onClose={() => setEdit(false)} onSaved={done} />
      <MoveDialog mode={mode} item={i} onClose={() => setMode(null)} onSaved={done} />
    </>
  );
}
